import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateBufferOrderMutationVariables = Types.Exact<{
  event_id: Types.Scalars['ID'];
}>;


export type CreateBufferOrderMutation = { __typename?: 'Mutation', createBufferOrder: string };


export const CreateBufferOrderDocument = gql`
    mutation CreateBufferOrder($event_id: ID!) {
  createBufferOrder(event_id: $event_id)
}
    `;
export type CreateBufferOrderMutationFn = Apollo.MutationFunction<CreateBufferOrderMutation, CreateBufferOrderMutationVariables>;

/**
 * __useCreateBufferOrderMutation__
 *
 * To run a mutation, you first call `useCreateBufferOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBufferOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBufferOrderMutation, { data, loading, error }] = useCreateBufferOrderMutation({
 *   variables: {
 *      event_id: // value for 'event_id'
 *   },
 * });
 */
export function useCreateBufferOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateBufferOrderMutation, CreateBufferOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBufferOrderMutation, CreateBufferOrderMutationVariables>(CreateBufferOrderDocument, options);
      }
export type CreateBufferOrderMutationHookResult = ReturnType<typeof useCreateBufferOrderMutation>;
export type CreateBufferOrderMutationResult = Apollo.MutationResult<CreateBufferOrderMutation>;
export type CreateBufferOrderMutationOptions = Apollo.BaseMutationOptions<CreateBufferOrderMutation, CreateBufferOrderMutationVariables>;